import { BACKEND_URL } from "@/lib/backendUrl";
import axios from "axios";

import i18n from "@/i18n";

const API = `${BACKEND_URL}/api`;
export const TOKEN_KEY = "servecor_token";

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export function apiError(err) {
  const t = i18n.t.bind(i18n);
  const detail = err?.response?.data?.detail;
  if (detail == null) return t(err?.message || "Something went wrong.");
  if (typeof detail === "string") return t(detail);
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? t(e.msg) : JSON.stringify(e))).join(" ");
  if (typeof detail === "object" && typeof detail.message === "string") return t(detail.message);
  return String(detail);
}

export function decisionPayload(err) {
  const detail = err?.response?.data?.detail;
  if (detail && typeof detail === "object" && detail.decision) return detail.decision;
  return null;
}
